import React, {
    Component,
    PropTypes
} from 'react';

import bumpService from 'SERVICES/purifier/bump/bumpService'
import {language, pageOption, resultTip} from 'UTIL/common'
import {
    Link
} from "react-router";
import SearchSelect from "../../../component/search/searchSelect";
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import {timesTampsToData}from '../../../function'
import Modal from "../../../component/modal";
import ModalHeader from "CONFIG/component/modalHeader";
import ModalFooter from "CONFIG/component/modalFooter";
import Tip from "CONFIG/component/tip";
export default class DvcStateIndex extends Component {
    constructor(props) {
        super(props);
        this.search = this.search.bind(this);
        this.state = {
            list: [],
            pageSize: 10,
            page: 1,
            total: 0,
            updateList:{},
        }
    };

    componentDidMount() {
        this.onPageChange(this.state.page, this.state.pageSize);
    }

    onPageChange(page, sizePerPage, e) {
        this.setState({
            page: page,
            pageSize: sizePerPage,
        });
        var dvcCode = $.trim($("#search").val());
        const arr = {
            "page": page,
            "pageSize": sizePerPage,
            "search": dvcCode,
        };
        var data = JSON.stringify(arr);
        bumpService.fetchDvcState({data}).then(msg => {
                console.log(msg);
                const json = msg.data;
                this.setState({
                    total: json.total,
                    list: json.records,
                })
            }
        )
    }

    search() {
        this.onPageChange(this.state.page, this.state.pageSize);
    }

    stateType(cell, row) {
        return row.cState == 1?"在线":"掉线"
    }
    isPushType(cell,row){
        return row.ispush == '"0"'?'否':'是';
    }
    reset(){
        $("#search").val('');
        this.onPageChange(1,10)
    }
    dataHandle(cell,row){
        return row.lastConnectTime == null?"":timesTampsToData(row.lastConnectTime);
    }
    update(cell,row){
        return <div>
            <a  className="btn btn-success btn-sm" data-target="#updateModal" data-toggle="modal"
                onClick={()=>{this.setState({updateList:row})}}>更新</a>
        </div>
    }
    updateSure(){
        let data = {
            deviceNo: this.state.updateList.deviceNo,
            openId: this.state.updateList.openId,
            productId: this.state.updateList.productId,
        };
        data = JSON.stringify(data);
        bumpService.sendCommandByState({data}).then(body=>{
            console.log(body)
            this.onPageChange(1,this.state.pageSize);
            resultTip(body);
        })
    }
    render() {
        let options = pageOption(this.state.page, this.state.pageSize);
        options['onPageChange'] = this.onPageChange.bind(this);
        const _this = this;
        options['paginationShowsTotal'] =function () {
            return <span style={{paddingRight:'10px'}}>
                共 <span className="bg-blue" style={{fontSize:'20px',padding:'2px 4px',borderRadius:'5px'}}>{_this.state.total}</span> 条数据
            </span>
        };
        return (
            <div >
                <section className="content-header ">
                    <h1> {language()['AirPurifierManagement']}
                        <small>设备在线查询</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-list"></i>
                            <h3 className="box-title">设备列表</h3>
                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <div className="title-box">
                                <div className="clearfix">
                                    <div className="f1">
                                        <label className="control-name fl">查询条件</label>
                                        <input type="text" className="form-control" id='search'
                                               placeholder={language()['deviceID']}/>
                                    </div>
                                    <button type="button" className="btn btn-info" onClick={this.search.bind(this)}>{language()['query']}</button>
                                    &nbsp;&nbsp;
                                    <button type="button" className="btn btn-warning" id="reset" onClick={this.reset.bind(this)}>
                                        {language()['resetting']}
                                    </button>
                                </div>
                            </div>
                            <BootstrapTable data={this.state.list} remote={true} fetchInfo={{dataTotalSize: this.state.total}} striped
                                            hover pagination={true} options={options} ref='table'>
                                <TableHeaderColumn isKey dataField='id'hidden="true"  >id </TableHeaderColumn>
                                <TableHeaderColumn dataField='deviceNo' width="200">{language()['deviceID']}</TableHeaderColumn>
                                <TableHeaderColumn dataField='openId' width="200">厂商ID</TableHeaderColumn>
                                <TableHeaderColumn dataField='productId' width="200">产品ID</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={this.stateType} width="120">连接状态</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={this.dataHandle.bind(this)} width="200">最近一次掉线时间</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={this.update.bind(this)} width="80">操作</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </section>
                <Modal modal={{"id":"updateModal","title":"Update","text":"readyUpdate"}}  modalSure= {this.updateSure.bind(this)}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/bump/back/dvcBase/dvcStateIndex.js